/**
 * Legacy API error payloads that expose a single user-facing message.
 */
export interface ErrorMessageDetails {
    readonly message?: string | null;
}
